import { useState } from "react";
import { ArrowClockwise, UploadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";

export async function retryImport(jobId) {
  try {
    await api.post(`/import/${jobId}/retry`);
    toast.success("Trying again, picking up your saved file");
    return true;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Couldn't retry that import. Please upload the file again.");
    return false;
  }
}

export function ImportRetry({ jobId, retryable, onRetried }) {
  const [busy, setBusy] = useState(false);
  if (!retryable) {
    return (
      <a href="/import" data-testid="import-upload-again-btn"
         className="mt-3 inline-flex items-center gap-2 px-5 py-2 rounded-full border border-rf-ink/20 text-sm font-semibold text-rf-ink hover:bg-rf-cream transition-colors">
        <UploadSimple size={16} /> Upload the file again
      </a>
    );
  }
  const go = async () => {
    setBusy(true);
    if (await retryImport(jobId)) onRetried?.();
    setBusy(false);
  };
  return (
    <button type="button" onClick={go} disabled={busy} data-testid="import-retry-btn"
            className="mt-3 inline-flex items-center gap-2 px-5 py-2 rounded-full bg-rf-orange text-white text-sm font-semibold hover:bg-rf-orange/90 disabled:opacity-60 transition-colors">
      <ArrowClockwise size={16} className={busy ? "animate-spin" : ""} /> {busy ? "Restarting…" : "Try again"}
    </button>
  );
}
